// https://www.drupal.org/project/webform_rest/issues/3093890

// Some Webform Fields (e.g. webform_address, webform_name) consist of composite fields, which are objects.
// drupal/webform_rest does not handle that yet. Keys and values are stringified, like so: 'address][address'
//
// So for errorhandling on composite webform fields, we need some extra logic.

var getNestedFieldvalue = function getNestedFieldvalue(fieldName, object) {
  var compositeCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '][';
  var nestedFieldname = fieldName.split(compositeCharacter);
  if (Object.keys(object).length && object[nestedFieldname[0]]) {
    return nestedFieldname[1] ? object[nestedFieldname[0]][nestedFieldname[1]] : object[fieldName];
  }
  return '';
};
export default getNestedFieldvalue;